export default __webpack_public_path__ + "static/media/sunset.c2351d75.svg";